(function () {
  const container = document.querySelector(".mobile-tabs");
  if (!container) return;

  const tabs = Array.from(container.querySelectorAll(".mobile-tabs__row > [role='tab']"));
  const panels = Array.from(container.querySelectorAll(".mobile-tabs__viewport > .mobile-tabs__panels > [role='tabpanel']"));
  const viewport = container.querySelector(".mobile-tabs__viewport");
  if (!tabs.length || !panels.length || !viewport) return;

  const TRANSITION_MS = 1200;
  let currentIndex = 0;
  let targetIndex = 0;
  let transitionTimeoutId = null;

  function getPanelHeight(panel) {
    const wasHidden = panel.hidden;
    panel.hidden = false;

    panel.classList.add("mobile-tabs__panel--measuring");

    const height = panel.offsetHeight;

    panel.classList.remove("mobile-tabs__panel--measuring");

    if (wasHidden) {
      panel.hidden = true;
    }

    return height;
  }

  function setViewportHeight(height) {
    viewport.style.height = `${height}px`;
  }

  function runTransition(fromIndex, toIndex) {
    if (fromIndex === toIndex) return;

    const oldPanel = panels[fromIndex];
    const newPanel = panels[toIndex];

    if (transitionTimeoutId) {
      clearTimeout(transitionTimeoutId);
      transitionTimeoutId = null;

      panels[currentIndex].classList.remove("mobile-tabs__panel--exiting");
      panels[currentIndex].hidden = true;

      const fromPanel = panels[fromIndex];
      fromPanel.classList.remove("mobile-tabs__panel--entering");
      fromPanel.classList.remove("mobile-tabs__panel--exiting");
      fromPanel.classList.add("mobile-tabs__panel--active");
      fromPanel.hidden = false;
    }

    const newHeight = getPanelHeight(newPanel);
    newPanel.hidden = false;
    void newPanel.offsetHeight;
    newPanel.classList.add("mobile-tabs__panel--entering");

    oldPanel.classList.remove("mobile-tabs__panel--active");
    oldPanel.classList.add("mobile-tabs__panel--exiting");

    setViewportHeight(newHeight);

    tabs.forEach((tab, i) => {
      tab.setAttribute("aria-selected", i === toIndex);
      tab.classList.toggle("mobile-tabs__button--active", i === toIndex);
    });

    tabs[toIndex].focus();

    targetIndex = toIndex;

    transitionTimeoutId = setTimeout(() => {
      oldPanel.classList.remove("mobile-tabs__panel--exiting");
      oldPanel.hidden = true;
      newPanel.classList.remove("mobile-tabs__panel--entering");
      newPanel.classList.add("mobile-tabs__panel--active");
      currentIndex = toIndex;
      transitionTimeoutId = null;
    }, TRANSITION_MS);
  }

  function switchTo(index) {
    const nextIndex = Math.max(0, Math.min(index, panels.length - 1));
    if (nextIndex === currentIndex && !transitionTimeoutId) return;

    const fromIndex = transitionTimeoutId ? targetIndex : currentIndex;
    runTransition(fromIndex, nextIndex);
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => switchTo(index));
  });

  container.addEventListener("keydown", (e) => {
    const effectiveIndex = transitionTimeoutId ? targetIndex : currentIndex;
    let nextIndex = effectiveIndex;

    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      e.preventDefault();
      nextIndex = Math.min(effectiveIndex + 1, tabs.length - 1);
    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      e.preventDefault();
      nextIndex = Math.max(effectiveIndex - 1, 0);
    } else if (e.key === "Home") {
      e.preventDefault();
      nextIndex = 0;
    } else if (e.key === "End") {
      e.preventDefault();
      nextIndex = tabs.length - 1;
    } else return;

    switchTo(nextIndex);
  });

  function updateViewportHeight() {
    if (transitionTimeoutId) return;

    const height = getPanelHeight(panels[currentIndex]);
    if (height > 0) {
      setViewportHeight(height);
    }
  }

  updateViewportHeight();
  const resizeObserver = new ResizeObserver(updateViewportHeight);
  resizeObserver.observe(container);

  const panelsContainer = container.querySelector(".mobile-tabs__panels");
  if (panelsContainer) {
    resizeObserver.observe(panelsContainer);
  }

  const mobileCarousel = document.querySelector(".pdp-carousel--mobile");

  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href="#provenance-proof-points"]');
    if (!link || !mobileCarousel?.contains(link)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const provenanceItem = container.querySelector(
      ".accordion__item[data-provenance]",
    );
    if (!provenanceItem) return;

    const panel = provenanceItem.closest("[role='tabpanel']");
    const panelIndex = panels.indexOf(panel);

    if (panelIndex >= 0 && panelIndex !== currentIndex) {
      switchTo(panelIndex);
    }

    if (!provenanceItem.classList.contains("accordion__item--expanded")) {
      const trigger = provenanceItem.querySelector(".accordion__trigger");
      if (trigger) trigger.click();
    }

    const tabRow = container.querySelector(".mobile-tabs__row");
    (tabRow || container).scrollIntoView({ behavior: "smooth", block: "start" });
  }, true);
})();
